<template>
	<div data-layout="remote">
		<router-view />
	</div>
</template>

<script>
	export default {};
</script>
